module.exports = __webpack_public_path__ + "static/media/messenger-b.814b02c2.svg";